module.exports = __webpack_public_path__ + "static/media/grace.84812e1e.jpeg";